export default "__VITE_ASSET__DAkF$yS6__"